import { Button, Crossmark } from '@talos/kyoko';
import type { PropsWithChildren, ReactNode } from 'react';
import { envConfig } from '../../utils/envConfig';
import type { ErrorBoundaryProps } from './ErrorBoundary';
import { ErrorContainer, Wrapper } from './styles';

export const ErrorBoundaryDisplay = (
  props: PropsWithChildren<{ message?: ReactNode; onReload?: ErrorBoundaryProps['onReload'] }>
) => {
  const { onReload, message, ...wrapperProps } = props;
  return (
    <Wrapper {...wrapperProps}>
      <ErrorContainer>
        <div>
          <Crossmark />
        </div>
        <div>
          {message || (
            <>
              <p>An unexpected error occurred.</p>
              <p>Please refresh the page.</p>
              <p>
                If this issue persists, please get in touch with Talos support and we will resolve the problem as soon
                as possible.
              </p>
              <p>
                <a href="mailto:support@talos.com">support@talos.com</a>
              </p>
              <p>{envConfig.VITE_SUPPORT_PHONE}</p>
              <Button data-testid="error-boundary-reload-content-button" onClick={onReload}>
                Reload content
              </Button>
            </>
          )}
        </div>
      </ErrorContainer>
    </Wrapper>
  );
};
